import apiUrl from '../../../utils/settings';

export const LoginUrl = () => {
  return apiUrl + '/auth/login';
};
export const LogoutUrl = () => {
  return apiUrl + '/auth/logout';
};
export const RegisterUrl = () => {
  return apiUrl + '/auth/register';
};
export const GetMeUrl = () => {
  return apiUrl + '/users/me';
};
export const getEditRequestsUrl = () => {
  return apiUrl + '/users/get-edited-pending-user-company-details';
};
export const getSecondaryPermissionsUrl = () => {
  return apiUrl + '/secondary-permissions/get-secondary-permissions';
};
export const getProductPriceVisibilityStatusUrl = () => {
  return apiUrl + '/price-visibility-user/get-price-visibility-status';
};
export const GetMeUsingPhoneNumberUrl = (phoneNumber) => {
  return apiUrl + `/users/get?phone_number=${phoneNumber}`;
};
export const CompanyUrl = () => {
  return apiUrl + '/company/get-companies-by-type-list';
};
export const GetActiveCompaniesByDistrictUrl = () => {
  return apiUrl + '/onboarding/active_companies_by_district';
};
export const GetAllIndustryManufacturersUrl = () => {
  return (
    apiUrl + '/manufacturer-company-setting/get-all-industry-manufacturers'
  );
};
export const DealerCompanyUrl = () => {
  return apiUrl + '/onboarding/get-dealer-companies';
};
export const getDitributorsWithCementCoIdForRetailerUrl = () => {
  return apiUrl + '/users/distributors-by-manufacturer-id-for-dealers';
};
export const getDitributorsWithCementCoIdForAssociateUrl = () => {
  return apiUrl + '/users/get-distributors-of-manufacturer-co';
};
export const GetOrderBookingLimitUrl = () => {
  return apiUrl + '/company-dispatch-order-booking-limit/get';
};
export const updateBookingOrderStatusByCompanyAdminUrl = () => {
  return apiUrl + '/order-booking/update-booking-order-status-by-company-admin';
};
export const getOrderBookingPaginatedUrl = () => {
  return apiUrl + '/order-booking/user-get-booking-orders-paginated';
};
export const updateOrderStatusByCompanyAdminUrl = () => {
  return apiUrl + '/user-orders/update-order-internal-status-by-company-admin';
};
export const DealerCompanyBaseProductPriceUrl = () => {
  return apiUrl + '/product-prices/get-company-base-product-price';
};
export const DealerCompanyBaseProductUrl = () => {
  return apiUrl + '/products/get-base-product-by-company';
};
export const createOrderBookingUrl = () => {
  return apiUrl + '/order-booking/create-booking-order';
};
export const VerifyMobileUrl = () => {
  return apiUrl + '/auth/verify-new-user';
};
export const GetProductUrl = () => {
  return apiUrl + '/products/get-products';
};
export const createOrderUrl = () => {
  return apiUrl + '/user-orders/create-order';
};
export const AllStateUrl = () => {
  return apiUrl + '/onboarding/get/all-state';
};
export const getOrderCostUrl = () => {
  return apiUrl + '/user-orders/calculate-order-amount';
};

export const AllCityUrl = () => {
  return apiUrl + '/onboarding/get/all_district';
};
export const OnboardingUrl = () => {
  return apiUrl + '/onboarding/add_user_details';
};

export const SearchProductByNameUrl = () => {
  return apiUrl + '/products/search-product-name';
};

export const SendOTPRequestOnboardingUrl = () => {
  return apiUrl + '/auth/send-otp-request';
};

export const SendOTPThroughExistingUserUrl = () => {
  return apiUrl + '/onboarding/send-otp-request-by-through-existing-user';
};
export const SendOTPToChangePhoneNumberUrl = () => {
  return apiUrl + '/auth/send-otp-request-to-change-phone_number';
};
export const VerifyOTPToChangePhoneNumberUrl = () => {
  return apiUrl + '/auth/verify-otp-to-change-user-phone_number';
};
export const VerifyToChangePhoneNumberOfCompanyOrUserUrl = () => {
  return apiUrl + '/auth/edit-user-company-phone-number';
};
export const addUserThroughExistingCompanyUrl = () => {
  return apiUrl + '/onboarding/add-user-through-existing-company';
};

export const VeriyOTPUrl = () => {
  return apiUrl + '/auth/verify-otp';
};
export const SendOTPByPhoneUrl = () => {
  return apiUrl + '/auth/send-otp-request-by-user-phone';
};
export const getSalesDataOfAMonthAndYearUrl = () => {
  return apiUrl + '/user-analytics/daily-buy-data-by-company-id';
};
export const DeleteAccountUrl = () => {
  return apiUrl + '/users/make-user-inactive';
};
export const LoginOtpUrl = () => {
  return apiUrl + '/auth/login-by-otp';
};
export const GetAllUserInsuranceCertificateUrl = () => {
  return apiUrl + '/benefit-packages/get-user-certificate-image-by-company-id';
};
export const ResetPasswordRequestUrl = () => {
  return apiUrl + '/auth/reset-password-request';
};
export const SetNewPasswordUrl = () => {
  return apiUrl + '/auth/set-new-password';
};
export const GetUserFiles = () => {
  return apiUrl + '/users-file/get-id-proof';
};
export const UpdateUserurl = () => {
  return apiUrl + '/users/update-user';
};
export const OnboardingAddDealerCompanyUrl = () => {
  return apiUrl + '/onboarding/add-dealer-companies';
};
export const GetDealerCompaniesUrl = () => {
  return apiUrl + '/onboarding/get-dealer-companies';
};
export const GetSubProductUrl = () => {
  return apiUrl + '/products/get-sub-products';
};
export const RemoveDealerCompaniesUrl = () => {
  return apiUrl + '/onboarding/remove-dealer-companies';
};
export const RemoveEmployeeOnboardedUrl = () => {
  return apiUrl + '/onboarding/delete-company-user';
};
export const benifitCheckWithPincodeUrl = () => {
  return apiUrl + '/pincode-benefits/get-by-pincode';
};
export const getDealerUsersListUrl = () => {
  return apiUrl + '/users/get/all_user_details_for_particular_company';
};
export const getBrandUrl = () => {
  return apiUrl + '/sale-products/get_all_sale_product';
};
export const getAllIndustryProductUrl = () => {
  return apiUrl + '/sale-products/get_all_sale_product_by_product_type';
};
export const GstUserGstDataFetchUrl = () => {
  return apiUrl + '/user-pan-and-gst/get-gstin-details';
};
export const GstUserPanDataFetchUrl = () => {
  return apiUrl + '/user-pan-and-gst/get-pan-details';
};
export const totalSaleTotalBuyUrl = () => {
  return apiUrl + '/user-inventory/get-user-analytics';
};
export const GetProductPricesUrl = () => {
  return apiUrl + '/price-list/price-list';
};
export const addRolePermissionUrl = () => {
  return apiUrl + '/secondary-permissions/assign-new-role-to-employee';
};
export const GstIndustriesUrl = () => {
  return apiUrl + '/manufacturer-company-setting/get-all-unique-industries';
};
export const GetDealerShipCompaniesWithIndustriesidUrl = () => {
  return (
    apiUrl +
    '/manufacturer-company-setting/get-manufacturers-of-particular-industry'
  );
};
export const CreateSecondaryOrderUrl = () => {
  return apiUrl + '/user-secondary-order/create-secondary-order';
};

export const GetSecondaryOrdersRetailerUrl = () => {
  return (
    apiUrl + '/user-secondary-order/user-get-all-secondary-orders-paginated'
  );
};

export const GetSecondaryOrdersUrl = () => {
  return (
    apiUrl +
    '/distributor-secondary-order/distributor-get-all-secondary-orders-paginated'
  );
};

export const SellDistributorUpdateApprovalStatusUrl = () => {
  return (
    apiUrl +
    '/distributor-secondary-order/update-secondary-order-approval-status-distributor'
  );
};

export const GetDistributorSecondaryOrderShowActionTriggerButtonUrl = () => {
  return apiUrl + '/distributor-secondary-order/distributor_show_action_trigger_button'
}

export const SellDistributorInventoryUrl = () => {
  return (
    apiUrl +
    '/distributor-secondary-order/update-secondary-order-by-inventory-distributor'
  );
};

export const SellDistributorViaPOUrl = () => {
  return (
    apiUrl +
    '/distributor-secondary-order/update-secondary-order-by-dispatch-plan-distributor'
  );
};
export const checkForInventoryForSellInSecondaryOrderActionUrl = () => {
  return (
    apiUrl +
    '/distributor-secondary-order/distributor-check-if-has-enough-inventory'
  );
};
export const getSkuDetailsUrl = () => {
  return apiUrl + '/product-sku/get-all-sku-value';
};
export const getSkuDetailsProductUrl = () => {
  return apiUrl + '/product-sku/get-product-sku-list';
};
export const editOrderBookingUrl = () => {
  return apiUrl + `/order-booking/edit-order-booking`;
};
export const deleteOrderBookingUrl = () => {
  return apiUrl + `/order-booking/delete-booking-order`;
};
